import { computed, observable } from 'mobx';
import { autobind } from 'core-decorators';
import useModal from '@src/utils/hooks/use-modal';
import AppointmentModalStore from '@src/business-components/appointment-modal/store';
import AppointmentModal from '@src/business-components/appointment-modal';
import PhoneAppointmentModal from '@src/business-components/phone-appointment-modal';
import PhoneAppointmentModalStore from '@src/business-components/phone-appointment-modal/store';
import AppoinmentSuccessModal from '@src/business-components/appointment-success-modal';
import useMount from '@src/utils/hooks/use-mount';
import OfficialCommunityStore from '@src/business-components/official-community/store';
import BaseStore from '@src/utils/store/base-store';
import routeConfigs from '@src/pages/app-router/route-configs';
import $$tracker from '@src/tracker';
import { aLink, getParameterByNames, noop } from '@src/utils/common-util';
import { getOmniData, KvDownloadChannelId, KvIds, newData } from '@src/services/omni-api';
import { isAndroid, isIOS, isMobile } from 'detect-mobile-device';
import Toast from '@src/components/toast';
class TopMenuStore extends BaseStore {
  appointmentModalStore = new AppointmentModalStore({
    appointmentByPhone: () => {
      this.phoneAppointmentModal.open();
    }
  });
  phoneAppointmentModalStore = new PhoneAppointmentModalStore({
    onSuccess: () => {
      this.appointmentSuccessModal.open();
      this.getConfigAsync && this.getConfigAsync();
    }
  });
  @observable getConfigAsync = noop;

  officialCommunityStore = new OfficialCommunityStore({ type: 'top' });
  /**
   * 游戏名称
   */
  @observable title;
  /**
   * 游戏副标题
   */
  @observable subTitle;
  /**
   * 游戏图标
   */
  @observable Icon;
  /**
   * 导航列表
   */
  @observable menuList;
  /**
   * 导航状态
   */
  @observable menuState;

  /**
   * 官方媒体状态
   */
  @observable officialListState;

  /**
   * 官网地址
   */
  @observable indexWebUrl;

  @observable state;

  @observable game_stage_config;

  @observable downloadUrl;

  /**
   * 是否隐藏攻略
   */
  @observable isHideStrategyValue = false;

  getIsHideStrategy;

  @computed
  get isHideStrategy() {
    return this.getIsHideStrategy ? this.getIsHideStrategy() : this.isHideStrategyValue;
  }

  constructor({
    title = '剑网3',
    subTitle = '国创网游开山之作',
    Icon,
    menuList = [
      {
        name: '江湖快报',
        id: 'news'
      },
      {
        name: '游戏特色',
        id: 'feature'
      },
      {
        name: '门派',
        id: 'school'
      },
      {
        name: '攻略',
        id: 'data'
      },
      {
        name: '视听中心',
        id: 'media'
      }
    ],
    menuState,
    indexWebUrl,
    isHideStrategy = false
  } = {}) {
    super();
    this.title = title;
    this.subTitle = subTitle;
    this.Icon = Icon;
    this.menuList = menuList;
    this.menuState = menuState;
    this.indexWebUrl = indexWebUrl;
    if (typeof isHideStrategy === 'function') {
      this.getIsHideStrategy = isHideStrategy;
    } else {
      this.isHideStrategyValue = isHideStrategy;
    }
  }

  /**
   * 跳转到官网
   */
  @autobind
  onClickMoveToIndex() {
    if (this.indexWebUrl) {
      window.location.href = this.indexWebUrl;
    }
  }

  /**
   * 修改导航状态
   * @param state
   */
  @autobind
  onchangeMenu(state) {
    this.menuState = state;
    this.onChangeOfficialListState(false);
  }

  /**
   * @description 预约成功回调, 外部传入
   * @param {*} type 预约类型  PHONE: 手机号预约, SCAN_CODE: 扫描二维码预约
   */
  successCallback = type => {};

  /**
   * 立即预约
   */
  onAppointmentClick = () => {
    // this.appointmentModalStore.isDisableSend = false;
    this.appointmentModalStore.successCallback = this.successCallback;
    this.appointmentModal.open();
  };

  onAppointmentCompletedClick = () => {
    this.appointmentSuccessModal.open();
  };

  getCurrentSystem = () => {
    const ua = navigator.userAgent;
    if (/HarmonyOS|HuaweiBrowser|ArkWeb/.test(ua)) {
      return '鸿蒙';
    } else if (isIOS()) {
      return '苹果';
    } else if (isAndroid()) {
      return '安卓';
    } else if (!isMobile()) {
      return 'PC端';
    }
    return '其他';
  };

  onDownloadClick = () => {
    $$tracker.clickToDownload(this.getCurrentSystem());

    const url = isAndroid() ? this.downloadUrl?.android : this.downloadUrl?.apple;
    if (url) {
      aLink(url);
    } else {
      Toast.info('敬请期待');
    }
  };

  onChangeOfficialListState = state => {
    this.officialListState = state;
  };

  getCategoryId = currentTab => {
    return newData.find(item => item.title === currentTab)?.id;
  };
  /**
   * 点击跳转到对应节点
   * @param tab
   */
  @autobind
  onClickRightNav(tab, id) {
    // console.log(`点击跳转到:${tab}`);
    $$tracker.clickTopNav(tab);
    // 去掉菜单栏目中新闻跳转到新闻列表页的逻辑，改为锚点到首页的新闻列表部分
    // if (id === 'news') {
    //   // this.redirect(routeConfigs.NEWS_LIST.getFormatPath({ categoryId: 'news', page: 1 }));
    //   aLink(window.location.origin + window.location.pathname + `#/news-list?categoryId=${this.getCategoryId('最新')}`);
    // }
    // 攻略资料同样改为锚点定位, 不再单独跳转攻略列表页
    this.redirect(routeConfigs.MAIN.getFormatPath({ part: id }));
  }

  getKVInfoAsync = () => {
    const dataSources = Object.values(KvIds).map(tab => {
      return {
        dataSourceId: tab || '',
        page: 1,
        perPage: 99
      };
    });
    return getOmniData(KvDownloadChannelId, dataSources)
      .then(res => {
        const stage = res?.[KvIds.stage]?.result?.items?.[0];
        this.game_stage_config = stage?.game_stage_config || 'appointment';
        if (this.game_stage_config === 'appointment') {
          this.state = 3;
        } else if (this.game_stage_config === 'pre_download') {
          this.state = 2;
        } else {
          this.state = 1;
        }

        const downloadUrl = {};
        const download = res?.[KvIds.default_download]?.result?.items || [];
        download.forEach(element => {
          downloadUrl[element.download_channel_code] = element.download_link?.url || element.channel_qrcode?.[0]?.url;
        });

        const utmSource = getParameterByNames('utm_source');
        const utmInfo = res?.[KvIds.custom_download]?.result?.items || [];
        if (utmSource) {
          const utmUrl = utmInfo.find(it => it.download_channel_code === 'utm_source' && it.utm_source === utmSource)?.download_link?.url;
          if (utmUrl) {
            downloadUrl.android = utmUrl;
            downloadUrl.qrcode = utmUrl;
          }
        }
        this.downloadUrl = downloadUrl;
      })
      .catch(error => {
        console.log(error);
        // Toast.fail(error?.msg);
      });
  };

  use() {
    super.use();
    this.appointmentModal = useModal(AppointmentModal, { store: this.appointmentModalStore });
    this.phoneAppointmentModal = useModal(PhoneAppointmentModal, {
      store: this.phoneAppointmentModalStore
    });
    this.appointmentSuccessModal = useModal(AppoinmentSuccessModal);

    useMount(() => {
      this.getKVInfoAsync();
      // this.onAppointmentClick();
    });
  }
}
export default TopMenuStore;
